module.exports = __webpack_public_path__ + "img/engagement_1.d0b73449.jpg";